import React, { Component } from "react";
import { Typography, Button } from "@material-ui/core";
import { Field } from 'redux-form';
import { Input } from 'scorpion-core';
import logo from '../../logo'

import View from 'react-flexbox'
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }


  handleFormSubmit(props) {
    this.props.signin(props.email, props.senha, () => this.props.history.push("/private/inicio"))
  }

  render() {
    const { handleSubmit, errorMensage } = this.props;
    return (<View style={{ justifyContent: "center" }}>
      <div style={{ maxWidth: 500 }}>
        <div style={{ display: 'flex', justifyContent: "center" }}>
          <img src={logo} />
        </div>
        {errorMensage && <Typography style={{ color: "#f00" }}> {errorMensage}</Typography>}
        <Field name="email" placeholder="Email" component={Input} />
        <Field name="senha" placeholder="Senha" type="password" component={Input} />
        <div style={{ display: 'flex', justifyContent: "center" }}>
          <Button variant="contained" color="primary" style={{ margin: 8 }} onClick={handleSubmit(this.handleFormSubmit)}>Login</Button>
          <Button variant="contained" color="primary" style={{ margin: 8 }} onClick={() => { this.props.history.push("/SignUp") }}>Criar Conta</Button>
        </div>
        {/* <Typography> Sign In</Typography>
        <Button variant="contained" color="primary" onClick={() => this.props.signinGoogle(() => { this.props.history.push("/private/inicio"); })}>siginGoogle</Button> */}
      </div>
    </View>
    );
  }
}


export default SignIn;


// WEBPACK FOOTER //
// ./src/routes/public/Login/components/SignIn/SignIn.js